import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAdmin } from '../contexts/AdminContext';
import { useAdminNavigationProtection } from '../hooks/useAdminNavigationProtection';

interface AdminRouteWrapperProps {
  children: React.ReactNode;
}

const AdminRouteWrapper: React.FC<AdminRouteWrapperProps> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const { isAdmin, isCheckingAdmin } = useAdmin();

  // Use the admin navigation protection hook
  useAdminNavigationProtection();

  useEffect(() => {
    // If admin is logged in and on login/signup pages, redirect to dashboard
    if (currentUser && isAdmin === true && !loading && !isCheckingAdmin) {
      if (window.location.pathname === '/admin/login' || window.location.pathname === '/admin/signup') {
        window.location.href = '/admin/control-panel-7x9k2m/overview';
      }
    }
  }, [currentUser, isAdmin, loading, isCheckingAdmin]);

  // Show loading while checking authentication and admin status
  // Also treat isAdmin === null as loading state (not yet determined)
  if (loading || isCheckingAdmin || isAdmin === null) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying admin access...</p>
        </div>
      </div>
    );
  }

  // Redirect to admin login ONLY if not authenticated OR explicitly not admin
  if (!currentUser || isAdmin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  // Render admin content
  return <>{children}</>;
};

export default AdminRouteWrapper;
